import React from "react";
import { Check } from "lucide-react";
import { fmtDateTime } from "../lib/format";

export default function ActivityItem({ a, onToggle, onOpen, showClient = true, canEdit = true }) {
  const done = a.stav === "HOTOVA";
  const overdue = a.po_terminu;
  const dot = overdue ? "bg-danger" : done ? "bg-success" : "bg-[#c9ced5]";

  return (
    <div
      onClick={() => onOpen?.(a)}
      role={onOpen ? "button" : undefined}
      tabIndex={onOpen ? 0 : undefined}
      onKeyDown={(e) => { if (onOpen && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); onOpen(a); } }}
      className={`flex items-center gap-3 py-3 px-4 border-b border-line-softer last:border-0 ${
        onOpen ? "cursor-pointer hover:bg-inputbg transition-colors" : ""}`}
      data-testid={`activity-${a.id}`}>
      <span className={`h-2 w-2 rounded-full shrink-0 ${dot}`} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="label-up px-1.5 py-0.5 rounded-chip bg-inputbg border border-line-strong text-muted">
            {a.typ}
          </span>
          <span className={`text-[13px] font-600 truncate ${done ? "text-muted line-through" : "text-ink"}`}>
            {a.nazev}
          </span>
        </div>
        <div className="text-[11.5px] text-muted mt-0.5 amount">
          {fmtDateTime(a.date_start)}
          {showClient && a.client_name ? <span className="font-sans"> · {a.client_name}</span> : ""}
          {a.obchodni_pripad?.nazev ? <span className="font-sans"> · {a.obchodni_pripad.nazev}</span> : ""}
          {overdue && <span className="text-danger font-sans font-600"> · po termínu</span>}
        </div>
      </div>
      {onToggle && canEdit && (
        <button
          onClick={(e) => { e.stopPropagation(); onToggle(a); }}
          data-testid={`toggle-${a.id}`}
          title={done ? "Označit jako otevřené" : "Označit jako hotové"}
          className={`h-7 w-7 rounded-icon border flex items-center justify-center shrink-0 transition-colors ${
            done ? "bg-success border-success text-white" : "border-line-strong text-muted hover:border-success hover:text-success"
          }`}
        >
          <Check size={14} strokeWidth={2.4} />
        </button>
      )}
    </div>
  );
}
